import React from 'react';
import { Loader2 } from '../icons';
import styles from './DestructiveButton.module.css';

interface DestructiveButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  children: React.ReactNode;
}

const DestructiveButtonBase = React.forwardRef<HTMLButtonElement, DestructiveButtonProps>(
  function DestructiveButton({ loading = false, disabled = false, children, className, ...rest }, ref) {
    const isInactive = loading || disabled;
    const classList: string[] = [styles.button ?? ''];
    if (disabled && !loading) classList.push(styles.buttonDisabled ?? '');
    if (loading) classList.push(styles.buttonLoading ?? '');
    if (className) classList.push(className);
    return (
      <button
        {...rest}
        ref={ref}
        disabled={isInactive}
        aria-busy={loading || undefined}
        className={classList.join(' ')}
      >
        {loading && <Loader2 size={16} className={styles.spinner} aria-hidden="true" />}
        {children}
      </button>
    );
  },
);

DestructiveButtonBase.displayName = 'DestructiveButton';
export const DestructiveButton = React.memo(DestructiveButtonBase);
DestructiveButton.displayName = 'DestructiveButton';
